module.exports = __webpack_public_path__ + "static/Q2_2022_Investor-Presentation-9a54e9a6ed67a1eac2288decc4f77785.pdf";